export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Mail/Components/SMTPConfigurationAdminConsole.vue'),
    contentData: {
        key: 'SMTPConfigurationAdminConsole',
        visible: true
    }
};